import { render, staticRenderFns } from "./DescriptionAssuranceAssurPlusComponent.vue?vue&type=template&id=247fd590&scoped=true"
import script from "./DescriptionAssuranceAssurPlusComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionAssuranceAssurPlusComponent.vue?vue&type=script&lang=js"
import style0 from "./DescriptionAssuranceAssurPlusComponent.vue?vue&type=style&index=0&id=247fd590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fd590",
  null
  
)

export default component.exports